<template>
  <v-text-field
    solo
    flat
    dense
    variant="underlined"
    required
    autocomplete="off"
    density="compact"
  />
</template>
